import { config } from "../../config";
import { SubledgerEndpoints } from "../../SubledgerEndpoints";
import { authPost } from "../../services/RequestHelpers";
import { ISlBatchInfo } from "../../schemas/SLBatchGridSchema";
import { RuntimeError } from "../../services/ErrorHelpers";
import { IUserProviderState } from "../../contexts/UserContext";

export async function getBatchEntryHeaders(
  batchRefGuid: string[],
  actionName: string,
  getTokenFn: IUserProviderState["accessToken"]
): Promise<ISlBatchInfo[]> {
  const batchDetails =
    actionName !== ""
      ? SubledgerEndpoints.slBatchEntryDetailsPerAction.replace("{actionName}", actionName)
      : SubledgerEndpoints.slBatchEntryDetails;
  const getSlBatchPopupUrl = config.get("subledgerUrl") + batchDetails;

  const resultsPromise = await authPost(getSlBatchPopupUrl, getTokenFn, batchRefGuid);
  if (!resultsPromise || !resultsPromise.data) {
    throw new RuntimeError(`Empty Payload from ${getSlBatchPopupUrl}`);
  }
  return resultsPromise.data as ISlBatchInfo[];
}
